export default {
    getShopMonitorInfo: {
        method: 'GET',
        url: '/manage-system/monitor/getShopMonitorInfo/{shopId}',
        name: '获取门店监控信息',
    },
    queryProblem: {
        method: 'POST',
        url: '/manage-system/monitor/queryProblem',
        name: '分页查询故障',
    },
    getShopWarningInfoList: {
        method: 'GET',
        url: '/manage-system/monitor/getShopWarningInfoList',
        name: '获取告警信息列表',
    },
    getShopWarningGrade: {
        method: 'POST',
        url: '/manage-system/monitor/getShopWarningGrade',
        name: '获取门店告警等级',
    },
}
